export const UserSessionEndpoints = {
  getUserSessions: 'getUserSessions',
  getUserSessionsInf: 'getUserSessionsInf',
  deleteUserSession: 'deleteUserSession',
  deleteAllUserSessions: 'deleteAllUserSessions',
} as const;

export const CIRRUS_USER_SESSIONS_URL = '/v1/account/user-sessions';
